import styled from 'styled-components';

export const PopupContainerMarker = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  background-color: rgb(22, 22, 21);
  padding: 10px;
  border-radius: 10px;
  width: 400px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 100;
  gap: 20px;
  ${({ theme }) => theme.device.mobile && !theme.device.landscape && `width:90%`}
`;

export const CloseButton = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 24px;
  color: white;
  cursor: pointer;
`;

export const Title = styled.div`
  color: white;
  font-size: 24px;
`;

export const Controls = styled.div`
  display: flex;
  align-items: center;
`;

export const ButtonPrimary = styled.button`
  background-color: var(--color-primary);
  color: white;
  border: none;
  padding: 5px 15px;
  border-radius: 20px;
  cursor: pointer;
  margin: 0 5px;
  &:hover {
    opacity: 0.7;
  }
`;

export const ButtonSecondary = styled.button`
  background-color: var(--color-secondary);
  //background-color: #444;
  color: white;
  border: none;
  padding: 5px 15px;
  border-radius: 20px;
  cursor: pointer;
  margin: 0 5px;
  &:hover {
    opacity: 0.7;
  }
`;
